import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=08b92ed2&scoped=true&"
import script from "./TicketDetail.vue?vue&type=script&lang=js&"
export * from "./TicketDetail.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=08b92ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b92ed2",
  null
  
)

export default component.exports